import React from "react";

export default function Analysis() {
  return <div>Analysis</div>;
}
